<template lang="pug">
h2
  | {{pagetitle}}
  v-tooltip(:tip="tip" pos="right")
    i.fa.fa-question-circle
  small(v-show="showTime") {{start === end ? start : `${start} - ${end}`}}
  slot

</template>
<script>
  import Store from '../store/store.js'
  export default {
    props: {
      pagetitle: String,
      tip: String,
      showTime : {
          type : Boolean,
          default : true
      }
    },
    store: Store,
    computed: {
       start() {
        return this.$store.state.start.replace(/-/g, '/')
      },
      end() {
        return this.$store.state.end.replace(/-/g, '/')
      }
     
    }
  }
</script>
<style scoped>
small {
    font-family: Microsoft Yahei,sans-serif;
}
</style>



// WEBPACK FOOTER //
// pagetitle.vue?3f545ff6